// Kontrakt panelu obrad ↔ wtyczka desktop dla transmisji sesji rady.
// Lustro WebServer/CouncilStreamContracts.cs — enumy stringowe (JsonStringEnumConverter),
// pola PascalCase, tak jak w pozostałych odpowiedziach wtyczki.
//
// Dlaczego przez wtyczkę: przeglądarka na HTTPS nie połączy się z obs-websocket
// na pętli zwrotnej, nie zapisze plików napisów w udziale sieciowym ani nie wywoła
// kamery PTZ po HTTP z uwierzytelnieniem Digest. W Magistracie robił to program
// WPF stojący na sali obrad — wtyczka zajmuje jego miejsce.

export enum EObsOutputState {
  Stopped = "Stopped",
  Starting = "Starting",
  Started = "Started",
  Stopping = "Stopping",
}

export enum EObsOutputKind {
  Stream = "Stream",
  Record = "Record",
}

export enum EObsOutputAction {
  Start = "Start",
  Stop = "Stop",
  Toggle = "Toggle",
}

export interface IPluginCameraPreset {
  Id: string;
  Name: string | null;
  /** Numer presetu zaprogramowanego w kamerze. */
  Number: number;
}

export interface IPluginCamera {
  Id: string;
  Number: number;
  /** „Kamera #N". */
  Label: string | null;
  /** Scena OBS z obrazem tej kamery. */
  Scene: string | null;
  Presets: IPluginCameraPreset[];
}

export interface ICouncilStreamState {
  SupportsStreaming: boolean;
  CamerasEnabled: boolean;
  /** Czy na stanowisku realizatora działa proces OBS Studio. */
  ObsRunning: boolean;
  Connected: boolean;
  ObsVersion: string | null;
  WebSocketVersion: string | null;
  CurrentScene: string | null;
  Scenes: string[];
  DefaultScene: string | null;
  VotingScene: string | null;
  StreamState: EObsOutputState;
  RecordState: EObsOutputState;
  StreamSeconds: number;
  KbitsPerSec: number;
  Fps: number;
  DroppedFrames: number;
  TotalFrames: number;
  CongestionPercent: number;
  /** Katalog plików napisów; puste = napisy wyłączone. */
  OsdPath: string | null;
  Cameras: IPluginCamera[];
  Error: string | null;
}

export interface IObsSceneRequest {
  Name: string;
}

export interface IObsOutputRequest {
  Output: EObsOutputKind;
  Action: EObsOutputAction;
}

export interface IObsVotingSceneRequest {
  Active: boolean;
}

/**
 * Napisy OSD. Pominięta sekcja = plik nietykany, sekcja z pustą treścią = plik
 * czyszczony. Brzmienie komunikatów układa aplikacja, nie wtyczka — dzięki temu
 * da się je zmienić wydaniem front-endu, bez aktualizacji wtyczki u realizatora.
 */
export interface IOsdWriteRequest {
  Bar?: { Text: string | null; Seconds?: number | null };
  Title?: { Text: string | null };
  Speaker?: { Label: string | null; Function: string | null };
  ClearAll?: boolean;
}

export interface IPtzPresetRequest {
  /** Puste = pierwsza skonfigurowana kamera. */
  CameraId?: string | null;
  Preset: number;
  /** Czy przełączyć OBS na scenę tej kamery. */
  ChangeScene?: boolean;
}

export interface IPtzTestRequest {
  CameraId?: string | null;
  /** Wartości z formularza — pozwalają sprawdzić kamerę przed zapisem ustawień. */
  Address?: string | null;
  Login?: string | null;
  Password?: string | null;
}

export interface IPtzTestResponse {
  Ok: boolean;
  CurrentPreset: number | null;
  Error: string | null;
}
